import React, { useEffect, useState } from 'react';

import Globetrotter from '@reuters-graphics/chart-module-globetrotter';
import LoaderPanel from 'Components/common/LoaderPanel';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';
import fetchJson from 'Utils/fetchJson';
import { globalTopojsonURL } from 'Constants/locations';

const globe = new Globetrotter();
const chartContainer = React.createRef();

const Globe = ({ location }) => {
  const [topojson, setTopojson] = useState(null);

  const resize = debounce(() => {
    if (!topojson) return;
    globe.draw();
  }, 250);

  useEffect(() => {
    if (topojson) return;
    if (window.localStorage.getItem('globetopo')) {
      setTopojson(JSON.parse(window.localStorage.getItem('globetopo')));
      return;
    }
    fetchJson(globalTopojsonURL)
      .then(topojson => {
        setTopojson(topojson);
        window.localStorage.setItem('globetopo', JSON.stringify(topojson));
      });
  }, [topojson]);

  useEffect(() => {
    if (!topojson) return;
    globe
      .selection(chartContainer.current)
      .props({
        marker: {
          replacementThreshold: 50,
          radius: 8,
          strokeWidth: 1.5,
        },
      })
      .topojson(topojson)
      .location(location, location === 'europe' ? [13, 52] : null)
      .draw();
  }, [location, topojson]);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className={classnames(component, 'chart-container')}>
      <div className='globetrotter-chart-container' ref={chartContainer} />
      {!topojson && (
        <LoaderPanel height={187} />
      )}
    </div>
  );
};

export default Globe;
